import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Link } from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import PublicIcon from '@material-ui/icons/Public';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(() => ({
  paperBase: {
    padding: '10px 15px',
    margin: '5px 5px 15px',
    boxShadow: 'none',
  },
  listLabel: {
    fontWeight: '600',
    color: '#000',
  },
  listColor: {
    color: '#888',
  },
  iconTile: {
    background: '#ebebeb',
    padding: 5,
    borderRadius: 5,
    marginRight: 10,
  },
}));

const ServiceVehicleSettings = ({
  selectedVehicle,
  showCompactSettings = false,
  compact = false,
}) => {
  const {
    shorter_transit_radius_minutes,
    employees,
    home_base_address,
    id,
    name,
    is_service_bay,
  } = selectedVehicle || {};
  const classes = useStyles();

  const technicians = employees?.reduce((employee, val) => {
    const comma = employee.length ? ', ' : '';
    return `${employee}${comma}${val.first_name} ${val.last_name}`;
  }, '');

  if (compact) {
    return (
      <>
        {showCompactSettings && (
          <Paper className={classes.paperBase}>
            <Typography variant="h5" gutterBottom>
              {name} Settings
            </Typography>
            <Grid
              container
              direction="row"
              justify="space-between"
              xs={12}
              md={8}
            >
              {!!technicians && (
                <Grid item xs={2}>
                  <Typography color="textSecondary">
                    Technician{employees.length > 1 ? 's' : ''}
                  </Typography>
                  <Typography>{technicians}</Typography>
                </Grid>
              )}
              {!is_service_bay && (
                <>
                  {!!home_base_address && (
                    <Grid item xs={4}>
                      <Typography color="textSecondary">
                        Starting Address
                      </Typography>
                      <Typography>{home_base_address}</Typography>
                    </Grid>
                  )}
                  <Grid item xs={2}>
                    <Typography color="textSecondary">
                      Zip Code Service Area
                    </Typography>
                    <Typography>
                      <Link
                        href={`#/service-area/${id}`}
                        color="primary"
                        style={{ textDecoration: 'underline' }}
                      >
                        Link to map
                      </Link>
                    </Typography>
                  </Grid>
                  {!!shorter_transit_radius_minutes && (
                    <Grid item xs={2}>
                      <Typography color="textSecondary">
                        Maximum Drive Radius
                      </Typography>
                      <Typography>
                        {shorter_transit_radius_minutes} min(s)
                      </Typography>
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </Paper>
        )}
      </>
    );
  }

  return (
    <>
      <Paper className={classes.paperBase}>
        <Typography variant="h5" gutterBottom>
          {is_service_bay ? 'Service Bay' : 'Service Vehicle'} Settings
        </Typography>
        <Box mt={2} mb={2} display="flex" alignItems="center">
          <AssignmentIndIcon className={classes.iconTile} />
          <Typography variant="body2" className={classes.listColor}>
            <span className={classes.listLabel}>Technician: </span>
            {technicians}
          </Typography>
        </Box>
        {!is_service_bay && (
          <>
            <Box mt={2} mb={2} display="flex" alignItems="center">
              <RoomIcon className={classes.iconTile} />
              <Typography variant="body2" className={classes.listColor}>
                <span className={classes.listLabel}>Starting Address: </span>
                {home_base_address}
              </Typography>
            </Box>
            <Box mt={2} mb={2} display="flex" alignItems="center">
              <Box display="flex" alignItems="center" mr={1}>
                <PublicIcon className={classes.iconTile} />
                <Link
                  href={`#/service-area/${id}`}
                  color="primary"
                >
                  Zip Code Service Area
                </Link>
              </Box>
              <Box display="flex" alignItems="center">
                <LocalShippingIcon className={classes.iconTile} />
                <Typography variant="body2" className={classes.listColor}>
                  <span className={classes.listLabel}>
                    Maximum Drive Radius:{' '}
                  </span>
                  {shorter_transit_radius_minutes} min(s)
                </Typography>
              </Box>
            </Box>
          </>
        )}
      </Paper>
    </>
  );
};

export default ServiceVehicleSettings;
